import { baseUniDriverFactory } from '../utils/test-utils/unidriver';

export const sidebarSectionTitleDriverFactory = base => {
  return {
    ...baseUniDriverFactory(base),

    getText: () => base.text(),
  };
};
